export default "__VITE_ASSET__D16$Xd$s__"